import HealthClaimPage from '@/components/feature/HealthClaimPage'
import { Container, Title } from './styles'

const HealthClaim = () => {
  return (
    <Container>
      <Title>เคลมประกันสุขภาพและอุบัติเหตุ</Title>
      <HealthClaimPage />
    </Container>
  )
}

export default HealthClaim
